module.exports = __webpack_public_path__ + "static/media/socialdesign.a4869d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Splash/images/socialdesign.png
// module id = 1351
// module chunks = 0